import { serviceBundler } from '../../../App';
import { WebSocketMessageTypeOutgoing } from '../../../Enums/WebSocketMessageTypeOutgoing';
import { SettingsWebPortal } from '../../Settings/SettingsWebportal';

export class WsWebPortalUpdate {
  public Type!: WebSocketMessageTypeOutgoing;
  public SettingWebPortal!: SettingsWebPortal;
  public SessionInBrowserId!: string;

  constructor(settingsWebportal : SettingsWebPortal) {
    this.SettingWebPortal = settingsWebportal;
    this.Type = WebSocketMessageTypeOutgoing.WsWebPortalUpdate;
    this.SessionInBrowserId = serviceBundler.settingsWebportalService.sessionInBrowserId;
  }
}
